import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4 sm:px-6 lg:px-8">
      {/*
        On small screens (default), it's a card:
        bg-white, p-10, rounded-lg, shadow-xl, max-w-md, w-full

        On large screens (lg: prefix), these styles are removed or overridden.
        We explicitly set lg:bg-transparent, lg:p-0, lg:shadow-none, lg:rounded-none, lg:max-w-none, lg:w-auto
        to ensure it looks "normal" (not like a card).
      */}
      <div className="
        max-w-md w-full space-y-8 text-center
        bg-white dark:bg-gray-800 p-10 rounded-lg shadow-xl
        transform transition duration-500 hover:scale-105
        
        lg:bg-transparent lg:p-0 lg:rounded-none lg:shadow-none lg:max-w-none lg:w-auto lg:hover:scale-100
      ">
        <div className="text-9xl font-extrabold text-accent dark:text-accent animate-bounce">
          404
        </div>
        <h2 className="mt-6 text-4xl font-extrabold text-gray-900 dark:text-white tracking-tight">
          Oops! Page Not Found
        </h2>
        <p className="mt-2 text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
          It looks like you've ventured into uncharted territory. The page you're looking for doesn't exist.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-accent hover:bg-accent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition duration-300 ease-in-out transform hover:-translate-y-1"
          >
            <svg
              className="-ml-1 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
            Back to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}